import { CalendarToday, DateRange, Today } from '@mui/icons-material';
import { Box, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js';
import React from 'react';
import ChartSection from '../components/dashboard/ChartSection';
import DailyView from '../components/dashboard/DailyView';
import YearToDateView from '../components/dashboard/YearToDateView';
import useDashboardData from '../hooks/useDashboardData';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function DashboardPage() {
  const {
    activeTab,
    chartView,
    loading,
    selectedYear,
    selectedDailyYear,
    selectedDailyMonth,
    packageDetailsData,
    zoeShipmentTrackingData,
    dailyData,
    chartData,
    dailyChartData,
    availableYears,
    availableMonths,
    currentDate,
    handleTabChange,
    handleChartViewChange,
    handleYearChange,
    handleDailyYearChange,
    handleDailyMonthChange,
    handleNavigateToPackageDetails,
    handleNavigateToShipmentTracking,
    handleNavigateToShipmentStatus,
    handleNavigateToShipmentByDate,
    handleNavigateToPackageByDate
  } = useDashboardData();

  return (
    <div>
      <div style={{ marginTop: 40, padding: '15px 20px' }}>
        <Box
          mb={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, fontSize: '1.75rem' }}
          >
            Dashboard
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <CalendarToday sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ fontSize: '0.85rem' }}
            >
              {currentDate}
            </Typography>
          </Box>
        </Box>

        <div style={{ margin: '0 auto', width: '95%' }}>
          <Grid container spacing={3} sx={{ height: 'calc(100vh - 200px)' }}>
            <Grid item xs={12} md={6}>
              <ChartSection
                chartView={chartView}
                onChartViewChange={handleChartViewChange}
                chartData={chartData}
                dailyChartData={dailyChartData}
                dailyData={dailyData}
                loading={loading}
                selectedYear={selectedYear}
                selectedDailyYear={selectedDailyYear}
                selectedDailyMonth={selectedDailyMonth}
                availableYears={availableYears}
                availableMonths={availableMonths}
                onYearChange={handleYearChange}
                onDailyYearChange={handleDailyYearChange}
                onDailyMonthChange={handleDailyMonthChange}
                ytdPackageTotal={packageDetailsData?.ytd?.total}
                ytdShipmentTotal={zoeShipmentTrackingData?.ytd?.total}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: '100%' }}>
                <Paper sx={{ mb: 3 }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                    variant="fullWidth"
                  >
                    <Tab
                      label="Daily Overview"
                      icon={<Today />}
                      iconPosition="start"
                      sx={{ minHeight: 64, fontSize: '0.95rem' }}
                    />
                    <Tab
                      label="Year to Date"
                      icon={<DateRange />}
                      iconPosition="start"
                      sx={{ minHeight: 64, fontSize: '0.95rem' }}
                    />
                  </Tabs>
                </Paper>
                <Box>
                  {activeTab === 0 && (
                    <DailyView
                      packageDetailsData={packageDetailsData}
                      zoeShipmentTrackingData={zoeShipmentTrackingData}
                      loading={loading}
                      onNavigateToPackageByDate={handleNavigateToPackageByDate}
                      onNavigateToShipmentByDate={handleNavigateToShipmentByDate}
                    />
                  )}
                  {activeTab === 1 && (
                    <YearToDateView
                      packageDetailsData={packageDetailsData}
                      zoeShipmentTrackingData={zoeShipmentTrackingData}
                      loading={loading}
                      onNavigateToPackageDetails={handleNavigateToPackageDetails}
                      onNavigateToShipmentTracking={handleNavigateToShipmentTracking}
                      onNavigateToShipmentStatus={handleNavigateToShipmentStatus}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
